import { get_paywalls_state_config } from '../base';

export default get_paywalls_state_config({
    url: '/logins_after_mission',
    title: 'Logins After Mission',
    template: require('./view.html'),
    is_missions_required: true,
});
